import { ExistingFormElement } from '@formrails/form-builder/data-access';
import { ExistingFormElementDto } from '../dtos/existingFormElementDto';

/**
 * Mapper utility for converting between ExistingFormElementDto and ExistingFormElement model
 * Handles the conversion from API DTO to domain model
 */
export class ExistingFormElementMapper {
  /**
   * Converts an ExistingFormElementDto (API response) to an ExistingFormElement model
   * @param dto The existing form element DTO from the backend
   * @returns ExistingFormElement model ready for UI display
   */
  static toModel(dto: ExistingFormElementDto): ExistingFormElement {
    // Map labelText from API (preferred), with fallback to questionText for backward compatibility
    const labelText = dto.labelText || 
                      dto.questionText || // Backward compatibility
                      dto['text'] || 
                      dto['label'] || 
                      dto['question'] ||
                      dto.name;

    return {
      id: dto.id,
      name: dto.name,
      type: dto.type,
      labelText: labelText,
      questionText: dto.questionText, // Preserve for backward compatibility
      // Preserve any additional properties from the DTO
      ...Object.keys(dto).reduce((acc, key) => {
        if (!['id', 'name', 'type', 'labelText', 'questionText'].includes(key)) {
          acc[key] = dto[key];
        }
        return acc;
      }, {} as Record<string, any>)
    };
  }

  /**
   * Converts multiple ExistingFormElementDtos to ExistingFormElement models
   * @param dtos Array of existing form element DTOs
   * @returns Array of ExistingFormElement models
   */
  static toModelArray(dtos: ExistingFormElementDto[]): ExistingFormElement[] {
    return dtos.map(dto => this.toModel(dto));
  }
}

